<template>
  <div class="chat-page">
    <div class="host vm-videochat vm-videomode">
      <div class="vm-videochat-wrapper">
        <div class="vm-conversation-side">
          <div class="vm-side-header">
            <div class="vm-videochat-search-wrap">
              <input
                placeholder="Поиск комнат..."
                v-model="searchRoomControl"
                class="vm-videochat-search"
                type="text"
              />
            </div>
          </div>
          <div class="vm-side-subheader">
            Комнаты
          </div>
          <div class="vm-side-content">
            <div class="vm-item" v-for="item in list" :key="item.id">
              <router-link class="vm-item-link" :to="{ name: 'vuexchatroom', params: { id: item.id }}">
                <div style="display:flex; width:75%">
                  <div>
                    <i class="material-icons">meeting_room</i>
                  </div>
                  <div style="display:flex; flex-direction:column">
                    <span>{{ item.name }}</span>
                    <div style="font-size:10px; display:flex;">
                      <template v-if="item.id === $route.params.id">
                        <span :title="countUsers.users_num + ' участников'" style="margin-right:10px; display:flex; align-items:center"><i class="material-icons" style="font-size:11px; opacity:0.6; margin-right:3px">fiber_manual_record</i>{{countUsers.users_num}}</span>
                        <span v-if="countUsers.users_online > 0" :id="`popover-${$route.params.id}`" :title="countUsers.users_online + ' онлайн'" style="display:flex; margin-right:10px; align-items:center"><i class="material-icons" style="font-size:11px; color:yellowgreen; margin-right:3px">fiber_manual_record</i>{{countUsers.users_online}}</span>
                        <span v-if="countUsers.users_video > 0" :id="`video-${$route.params.id}`" style="display:flex; align-items:center" :title="countUsers.users_video + ' по видеосвязи'"><i class="material-icons" style="font-size:11px; color:yellowgreen; margin-right:3px">album</i>{{countUsers.users_video}}</span>
                        <b-popover v-if="countUsers.users_online > 0"
                          :target="`popover-${$route.params.id}`"
                          placement="bottom"
                          boundary="window"
                          title="Участники онлайн:"
                          triggers="hover focus click"
                        >
                          <div v-for="user in countUsers.list_users_online" :key="user.id">
                            <span class="material-icons" style="color:yellowgreen; vertical-align:middle; font-size:14px; margin-right:2px">fiber_manual_record</span>{{user.name.first}} {{user.name.last}}
                            <hr class="my-1">
                          </div>
                        </b-popover>
                        <b-popover v-if="countUsers.users_video > 0"
                          :target="`video-${$route.params.id}`"
                          placement="bottom"
                          boundary="window"
                          title="Участники на видеосвязи:"
                          triggers="hover focus"
                        >
                          <div v-for="user in countUsers.list_users_video" :key="user.id">
                            <span class="material-icons" style="color:yellowgreen; vertical-align:middle; font-size:14px; margin-right:2px">album</span>{{user.name.first}} {{user.name.last}}
                            <hr class="my-1">
                          </div>
                        </b-popover>
                      </template>
                      <template v-else>
                        <span :title="item.users_num + ' участников'" style="margin-right:10px; display:flex; align-items:center"><i class="material-icons" style="font-size:11px; opacity:0.6; margin-right:3px">fiber_manual_record</i>{{item.users_num}}</span>
                        <span v-if="item.users_online > 0" :id="`popover-${item.id}`" :title="item.users_online + ' онлайн'" style="display:flex; margin-right:10px; align-items:center"><i class="material-icons" style="font-size:11px; color:yellowgreen; margin-right:3px">fiber_manual_record</i>{{item.users_online}}</span>
                        <span v-if="item.users_video > 0" :id="`video-${item.id}`" style="display:flex; align-items:center" :title="item.users_video + ' по видеосвзяи'"><i class="material-icons" style="font-size:11px; color:yellowgreen; margin-right:3px">album</i>{{item.users_video}}</span>
                        <b-popover v-if="item.users_online > 0"
                          :target="`popover-${item.id}`"
                          placement="bottom"
                          boundary="window"
                          title="Участники онлайн:"
                          triggers="hover focus"
                        >
                          <div v-for="user in item.list_users_online" :key="user.id">
                            <span class="material-icons" style="color:yellowgreen; vertical-align:middle; font-size:14px; margin-right:2px">fiber_manual_record</span>{{user.firstName}} {{user.lastName}}
                            <hr class="my-1">
                          </div>
                        </b-popover>
                        <b-popover v-if="item.users_video > 0"
                          :target="`video-${item.id}`"
                          placement="bottom"
                          boundary="window"
                          title="Участники на видеосвязи:"
                          triggers="hover focus"
                        >
                          <div v-for="user in item.list_users_video" :key="user.id">
                            <span class="material-icons" style="color:yellowgreen; vertical-align:middle; font-size:14px; margin-right:2px">album</span>{{user.firstName}} {{user.lastName}}
                            <hr class="my-1">
                          </div>
                        </b-popover>
                      </template>
                    </div>

                  </div>
                </div>
                <div style="display:flex">
                  <span v-b-tooltip="{ title: 'пригласить в комнату', delay: {show: 100, hide:0}}" @click.stop.prevent="openAddPersonal(item.id)" class="material-icons button-add"> person_add </span>
                  <span v-b-tooltip="{ title: 'выйти из комнаты', delay: {show: 100, hide:0}}" @click.stop.prevent="exitRoom(item.id)" class="material-icons button-delete"> login </span>
                </div>
              </router-link>
            </div>
            <div v-if="!list.length" class="vm-empty-coversation-list">
              <div class="vm-empty-header">Списк комнат пуст</div>
              <div class="vm-empty-subheader">Создайте или подключитель к комнате</div>
              <i class="material-icons">arrow_downward</i>
            </div>
          </div>
          <div class="vm-side-footer">
            <form @submit.prevent="addParticipant">
              <div class="vm-videochat-search-wrap">
                <input
                  placeholder="Имя комнаты..."
                  v-model="conversationNameControl"
                  class="vm-videochat-search"
                  type="text"
                />
              </div>
              <button type="submit" class="vm-exit-button">	
                <i class="material-icons">login</i>	
              </button>
            </form>
          </div>
        </div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { chatApi } from '@app/services';

export default {
  data: () => ({
    searchRoomControl: null,
    conversationNameControl: null,
    cur_id: ''
  }),
  async beforeRouteUpdate(to, from, next) {
    this.$store.dispatch('chat/loadConversations');
    this.$store.commit('chat/setContentPage', 'chat');
    console.log(this.list);
    next();
  },
  async created() {    
    if (!this.$store.state.auth.is_auth){
      this.$router.push({name: 'main', params: {reverseURL: this.$route.params.id}});
      this.$store.commit('navigation/setLoginDialog', true);
      helper.toastErrorAuth();
    } else {
      await this.$store.dispatch('chat/loadConversations');
      const response = await Notification.requestPermission();
      if (response === 'granted') {
        this.subscribeUserToPush();
      }
      if (this.$route.params.id) {
       const findCon = this.$store.state.chat.conversations.find(obj => obj.id === this.$route.params.id);
        if (!findCon) {
          this.cur_id = this.$route.params.id;
          await this.addParticipant();
          this.$store.dispatch('chat/joinConversation', this.$route.params.id);
          await this.$store.dispatch('chat/loadConversations');
        }
      } else {
        if (this.$store.state.chat.session) {
          await this.$store.dispatch('chat/disconnect');
        }
      }
    }
  },
  methods: {
    async exitRoom(id) {
      await chatApi.exitConversation(id);
      await this.$store.dispatch('chat/loadConversations');
      if (this.$route.params.id === id) {
        this.$router.push({ name: 'vuexchat'});
        await this.$store.dispatch('chat/disconnect');
      }
    },
    openAddPersonal(uuid) {
      this.$route.params.uuid = uuid;
      this.$store.commit('chat/setContentPage', 'invite');
    },
    urlBase64ToUint8Array(base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4);
      const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },
    async subscribeUserToPush() {
      try {
        const registration = await navigator.serviceWorker.register('/service-worker.js');
        const subscribeOptions = {
          userVisibleOnly: true,
          applicationServerKey: this.urlBase64ToUint8Array(
            'BOqA1nMggWk2xKZoZDg9M023U5rT6qtMTZTkTJmEzMgiodjvXzS0FGbVIPxnDzJKrWfbT3hdNR7Wra7xzm5OazI'
          )
        };
        const data = await registration.pushManager.subscribe(subscribeOptions);
        const json = JSON.stringify(data);
        const obj = JSON.parse(json);
        console.log({ data, json, obj });
        const params = {
          endpoint: obj.endpoint,
          keys_p256: obj.keys.p256dh,
          keys_auth: obj.keys.auth
        };
        await chatApi.subscribeWebPush(params);
      } catch (err) {
        console.log('Error: ', err); 
        return false;
      }
    },
    back() {
      this.$router.push({ name: 'vuexchat' });
      this.$store.dispatch('chat/disconnect');
    },
    async addParticipant() {
      try {
        const response = await axios.post('/api/chat/conversation/', this.cur_id ? {conversationId: this.cur_id} : { name: this.conversationNameControl });
        const id = response.data.conversationId;
        this.conversationNameControl = null;
        if (!this.cur_id) {
          this.$router.push({ name: 'vuexchatroom', params: { id }});
        }
        this.cur_id = null;
      } catch(error) {
        toastr.error(error.response.data.errors);
        this.cur_id = null;
      }
    }
  },
  computed: {
    list() {
      return this.searchRoomControl ?
        this.$store.getters['chat/conversationList'].filter(({ name }) => {
          return name.toLowerCase().indexOf(this.searchRoomControl.toLowerCase()) > -1;
        }) :
        this.$store.getters['chat/conversationList'];
    },
    countUsers() {
      const data = {
        list_users_online: this.$store.state.chat.contacts.filter(c => {
              if (c.isOnline) {
                return c;
              }}),
        list_users_video: this.$store.state.chat.contacts.filter(c => {
              if (c.isStream) {
                return c;
              }}),
        users_num: this.$store.state.chat.contacts.length,
        users_online: this.$store.state.chat.contacts.filter(c => {
              if (c.isOnline) {
                return c;
              }}).length,
      users_video: this.$store.state.chat.contacts.filter(c => {
              if (c.isStream) {
                return c;
              }}).length,
      };
      return data;
    }
  }
};
</script>

<style lang="scss" scoped>
.vm-side-subheader {
  background-color: rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(255,255,255,.3);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 12px;
  text-transform: uppercase;
}
.vm-empty-coversation-list {
  color: white;
  text-align: center;
  margin-top: auto;
}
.vm-empty-coversation-list .vm-empty-header {
  font-size: 20px;
}
.vm-empty-coversation-list .vm-empty-subheader{
  font-weight: 300;
  font-size: 12px;
  margin-bottom: 12px;
}
.vm-exit-button {
  border: 0;
  background-color: transparent;
  color: #fff;
  outline: 0;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 46px;
}
.vm-exit-button i {
  font-size: 32px;
}
.chat-page {
  height: calc(100vh - 64px);
  background-color: white;
}
.vm-videochat {
  max-width: 1248px;
  padding: 24px;
  margin: auto;
  height: 100%;
}
.vm-videochat-title {
  text-transform: uppercase;
  font-size: 18px;
  color: RGB(53, 40, 77);
  font-weight: 500;
}
.vm-videochat-wrapper {
  display: flex;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
}
.vm-conversation-side {
  position: relative;
  background: linear-gradient(to bottom, #8c30da, #5c48d4);
  box-shadow: inset -30px 0 40px 0 rgba(0,0,0,.15);
  border-radius: 4px 0 0 4px;
  width: 250px;
  flex: 0 0 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.vm-conversation-side .vm-side-content {
  position: relative;
  flex: auto;
  overflow-y: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.vm-conversation-side .vm-menu {
  position: absolute;
  background-color: #fff;
  border-radius: 4px;
  right: 12px;
  top: 64px;
}
.vm-conversation-side .vm-side-footer form {
  display: flex;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}
/* .vm-conversation-side .vm-side-header .vm-videochat-search-wrap {
  padding-left: 0;
} */
.vm-conversation-side .vm-side-footer .vm-videochat-search-wrap {
  padding-right: 0;
}
.vm-conversation-side .vm-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.vm-conversation-side .vm-item-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: #fff;
  padding: 12px;
  text-decoration: none;
  font-weight: 600;
  font-size: 12px;
}
.vm-conversation-side .vm-item-link i {
  margin-right: 12px;
}
.vm-conversation-side .vm-item-link.router-link-active {
  background: linear-gradient(to left, #5d86ed57, #c742d365);
}
.button-delete {
  display: none;
  margin-left: 2px;
}
.button-add {
  display: none;
  margin-right: 2px;
}
.button-add:hover {
  color: lightgreen;
}
.button-delete:hover {
  color: red;
}

.vm-item-link:hover {
  .button-delete {
    display: flex;
    cursor: pointer;
    opacity: 0.6;
    transform: rotate(180deg);
  }
  .button-add {
    display: flex;
    cursor: pointer;
    opacity: 0.6;
  }
}
.vm-videochat-side {
  max-height: 100%;
  background: linear-gradient(to bottom, #8c30da, #5c48d4);
  z-index: 1;
}
.vm-side-header {
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.vm-videochat-search-wrap {
  padding: 12px;
  width: 100%;
}
.vm-videochat-search {
  display: block;
  border: 0;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  width: 100%;
  color: #fff;
  padding-left: 24px;
  height: 36px;
  outline: none;
}
.vm-videochat-search::placeholder {
  color: #fff;
  font-weight: 300;
}
.vm-contacts {
  overflow-y: auto;
  flex: auto;
}
.vm-videochat-content {
  flex: auto;
  border-radius: 0 4px 4px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(to right, rgb(242, 232, 251), rgb(234, 239, 250));
}
.vm-videochat-header {
  height: 60px;
  flex: 0 0 60px;
  border-radius: 0 4px 0 0;
  padding: 0 24px;
}
.vm-videochat-header-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.vm-videochat-header-action {
  margin-left: auto;
}
.vm-videochat-header button {
  border: 0;
  outline: 0;
  background-color: #5c48d4;
  display: flex;
  color: #fff;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
}
.vm-videochat-view {
  height: calc(100% - 120px);
  /*
  overflow-y: auto;
  padding: 24px;
  */
}
.vm-videochat-footer {
  min-height: 60px;
  background-color: white;
  border-radius: 0 0 4px 0;
  display: flex;
  flex-shrink: 0;
}
.vm-videochat-footer .vm-videochat-action {
  width: 60px;
  display: flex;
  align-items: flex-end;
}
.vm-videochat-enterarea {
  flex: auto;
  position: relative;
}
.vm-videochat-enterarea label {
  position: absolute;
  z-index: 1;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.vm-textarea-wrap {
  display: flex;
  align-items: center;
  height: 100%;
}
.vm-videochat-footer textarea {
  position: relative;
  z-index: 2;
  display: block;
  background-color: transparent;
  border: 0;
  width: 100%;
  outline: none;
  resize: none;
}
.vm-videochat-action label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border: 0;
  background-color: transparent;
  transform: rotate(45deg);
  color: RGB(190, 190, 190);
  margin: 0;
  padding: 0;
  cursor: pointer;
}
.vm-videochat-action input {
  display: none;
}
.vm-videochat-action button i {
  font-size: 36px;
}
.vm-videochat-action label:hover i {
  color: rgb(122, 52, 213);
}
/* virtual scroller */
.vm-scroller {
  height: 100%;
  padding: 24px;
  display: flex;
}
.vm-scroller >>> .vue-recycle-scroller__item-wrapper {
  margin-top: auto;
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.3);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.vm-videochat-header-action button {
  transition: all 300ms ease;
}
.vm-videochat-header-action button.red {
  background-color: red;
  transform: rotate(90deg);
}
@media (max-width: 1280px) {
  .vm-videochat-header {
    height: 48px;
    flex: 0 0 48px;
  }
  .vm-videochat-title {
    font-size: 14px;
  }
  .vm-videochat-subtitle {
    font-size: 12px;
  }
  .vm-videochat-header button {
    width: 32px;
    height: 32px;
  }
  .vm-videochat-header button i {
    font-size: 18px;
  }
  .vm-side-header {
    height: 48px;
  }
  .vm-videochat-side {
    width: 240px;
  }
  .vm-videochat-search {
    padding: 0 12px;
    height: 32px;
    font-size: 14px;
  }
  .vm-exit-button {
    height: 32px;
    flex: 0 0 32px;
  }
  .vm-exit-button i {
    font-size: 32px;
  }
  .vm-videochat-footer {
    min-height: 48px;
  }
  .vm-videochat-footer .vm-videochat-action {
    width: 48px;
  }
  .vm-videochat-action label {
    width: 48px;
    height: 48px;
  }
  .vm-videochat-footer textarea {
    font-size: 14px;
  }
}
.webcam {
  display: flex;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
